import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardMedia, Typography, Button, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import discordImg from 'assets/img/discord.png';

const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: 'flex',
  flexDirection: 'row',
  minHeight: 200,
}));

const StyledCardMedia = styled(CardMedia)({
  width: 200,
  height: 200,
  objectFit: 'contain',
  backgroundColor: 'rgba(0, 0, 0, 0.08)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  overflow: 'hidden',
  border: '2px solid rgba(0, 0, 0, 0.1)',
  padding: '8px',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: '50%',
  },
});

const StyledButton = styled(Button)(({ theme }) => ({
  alignSelf: 'center',
  marginLeft: 'auto',
  marginRight: theme.spacing(2),
  padding: theme.spacing(1),
  minWidth: 'unset',
  '& img': {
    width: '86px',
    height: 'auto',
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const TextContent = styled(Box)({
  flex: 1,
});

export default function DiscordTeamCard({ team }) {
  const { t } = useTranslation();

  console.log('team');
  console.log(team);

  return (
    <StyledCard>
      <StyledCardMedia
        component="img"
        src={team.logo_url || '/path/to/default-image.png'}
        alt={team.name}
      />
      <ContentBox>
        <TextContent>
          <Typography variant="h5" component="h2" gutterBottom>
            {team.name}
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            {team.description}
          </Typography>
        </TextContent>
        {team.invite_link && (
          <StyledButton
            component="a"
            href={team.invite_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={discordImg} alt="Join Discord" />
          </StyledButton>
        )}
      </ContentBox>
    </StyledCard>
  );
}
